import React from 'react';
import './TravelArrangementsCards.css';


const TravelArrangementsCards = () => {
    return (
        <>
            <div className='container tACardsContainer '>
                <div className='tACards tACard1'>
                    <div className='tAHeading'>
                        <h5 className='fw-bold'>PRE-DEPARTURE SUPPORT
                        </h5>
                    </div>
                    <div className='tAPara'>
                        <p>Experience a stress-free start to your journey with our comprehensive pre-departure assistance, including itinerary planning, booking confirmation, and all the details you need to hit the road with ease.
                        </p>
                    </div>
                </div>
                <div className='tACards tACard2'>
                    <div className='tAHeading'>
                        <h5 className='fw-bold'>STAY AHEAD, TRAVEL SMART
                        </h5>
                    </div>
                    <div className='tAPara'>
                        <p>Be fully prepared with real-time updates, travel tips, and destination insights that ensure you’re always ready for your next adventure. From weather forecasts to local recommendations, we’ve got you covered!
                        </p>
                    </div>
                </div>
                <div className='tACards tACard3'>
                    <div className='tAHeading'>
                        <h5 className='fw-bold'>YOUR SAFETY, OUR PRIORITY</h5>
                    </div>
                    <div className='tAPara'>
                        <p>We put your health and safety first by keeping you informed of the latest travel advisories, health protocols, and safety guidelines to ensure a secure and worry-free travel experience.
                        </p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TravelArrangementsCards